// What a Book card offers, worked out from the Book's state alone. Pure, so
// tests/client/dashboard-action.test.ts covers all eleven states without a
// DOM, and so the label and the route can never point at different screens.
import type { BookState } from "@contract";
import { WORKING_BOOK_STATES } from "../../api/poll";
import { bookLandingPath } from "../book/landing";

/** The actions a card can carry; each is a key under dashboard:action.*. */
export const DASHBOARD_ACTIONS = [
  "open",
  "confirm",
  "review",
  "render",
  "progress",
  "download",
  "failure",
] as const;
export type DashboardAction = (typeof DASHBOARD_ACTIONS)[number];

const BY_STATE: Readonly<Record<BookState, DashboardAction>> = Object.freeze({
  // Parse is running: the card is a working card and the link goes to the
  // Book page, which shows the job.
  uploaded: "open",
  parsed: "confirm",
  confirmed: "open",
  styleSheetReady: "open",
  calibrating: "review",
  refining: "review",
  inReview: "review",
  approved: "render",
  rendering: "progress",
  rendered: "download",
  // The retry lives on the Book page, next to the failed job it retries.
  failed: "failure",
});

export const dashboardAction = (state: BookState): DashboardAction => BY_STATE[state];

/** Full route for a card's action: the same screen /books/:id itself lands on. */
export const dashboardActionPath = (book: { id: string; state: BookState }): string =>
  bookLandingPath(book.id, book.state);

/**
 * Whether the card shows a spinner: the same set the list polls on
 * (src/client/api/poll.ts), so a spinning card is always a card that refreshes.
 */
export const isWorkingState = (state: BookState): boolean => WORKING_BOOK_STATES.has(state);
